export default __webpack_public_path__ + "static/media/cover2.ae09f446.jpg";